import { render } from "./signCenter.vue?vue&type=template&id=87f0d81c&scoped=true&ts=true"
import script from "./signCenter.vue?vue&type=script&lang=ts"
export * from "./signCenter.vue?vue&type=script&lang=ts"

import "./signCenter.vue?vue&type=style&index=0&id=87f0d81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f0d81c"]])

export default __exports__